<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <SlidePricing />
    <SlideFooter />
    <SlideCopyright />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import SlideCopyright from "@/components/views/PageMainHome/V3SlideCopyright.vue";
import SlideFooter from "@/components/views/PageMainHome/V6SlideFooter.vue";
import SlidePricing from "@/components/views/PageMainHome/V6SlidePricing.vue";

export default {
  components: {
    SlideCopyright,
    SlideFooter,
    SlidePricing,
  },
  computed: mapState({
    //
  }),
  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
  }),
  created() {
    //BOC:[breadcrumbs]
    this.breadcrumbs.push({
      text: this.$t("route.PageMainHome"),
      to: { name: 'PageMainHome' },
      exact: true,
    })
    this.breadcrumbs.push({
      text: this.$t("route.PageMainPricing"),
      to: { name: 'PageMainPricing' },
      exact: true,
    })
    //EOC
  },
  mounted() {
    //
  },
  methods: {
    //
  }
}
</script>